import React, { MutableRefObject, useEffect, useRef, useState } from "react";
import { LayerGroup, LayersControl, MapContainer, Marker, Polygon, Popup, TileLayer, useMapEvents, ZoomControl } from "react-leaflet";
import 'leaflet/dist/leaflet.css';
import L, { LatLng, latLng, marker } from 'leaflet';
import { useLeafletContext } from '@react-leaflet/core'
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import { Button, Card, Checkbox, Descriptions, Empty, message, Modal, notification, Radio, Skeleton, Slider, Spin, Tag, Tooltip, Typography } from "antd";
import type { MenuProps } from 'antd';
import { Menu } from 'antd';
import ScenariaService from "../services/scenaria-service";
import 'leaflet-contour';
import { AnalysisDataReceptorModel } from "../models/analysis-data-receptor-model";
import { groupBy, take } from "lodash";
import Plot from 'react-plotly.js';
import { useParams } from "react-router-dom";
import { ScenarioModel } from "../models/scenario-model";
import { PollutantModel } from "../models/pollutant-model";
import { AnalysisModel } from "../models/analysis-model";
import { CaretRightOutlined, CheckOutlined, CloseOutlined, DownloadOutlined, PauseOutlined, StepBackwardOutlined, StepForwardOutlined, UndoOutlined } from "@ant-design/icons";
import { AnalysisContourLinesModel } from "../models/analysis-countour-lines-model";
import dayjs from "dayjs";
import { forkJoin } from "rxjs";
import { ClickMarkerModel } from "../models/click-marker-model";
import qelng from '../QELNG-logo.jpg'
import tamuq from '../TAMUQ-logo.png'
import report from '../report.png'

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;




// function Contour(props:any) {
//     const context = useLeafletContext()

//   useEffect(() => {
//     const allData : AnalysisDataReceptorModel[]|undefined = props.data;
//     if (allData === undefined) return;
//     const data = take(allData, 90);


//     const xRow = data.map(rm => rm.lat);
//     const x = data.map(rm => xRow);

//     const y = data.map((rm, i) => {
//         return data.map(rm2=>data[i].long);
//     });

//     const z = data.map((rm,i) => {
//         return data.map((rm2,j)=> {
//             if (i !== j) return null;
//             if (rm2.data[0].concentration === 0) return 2;
//             return 4;
//         })
//     });


//     // const x= [
//     //     [8.475, 8.5, 8.525, 8.55, 8.575, 8.6, 8.625],
//     //     [8.475, 8.5, 8.525, 8.55, 8.575, 8.6, 8.625],
//     //     [8.475, 8.5, 8.525, 8.55, 8.575, 8.6, 8.625],
//     //     [8.475, 8.5, 8.525, 8.55, 8.575, 8.6, 8.625],
//     //     [8.475, 8.5, 8.525, 8.55, 8.575, 8.6, 8.625],
//     //     [8.475, 8.5, 8.525, 8.55, 8.575, 8.6, 8.625],
//     //     [8.475, 8.5, 8.525, 8.55, 8.575, 8.6, 8.625],
//     //     ];
//     // const y= [
//     //     [47.42, 47.42, 47.42, 47.42, 47.42, 47.42, 47.42],
//     //     [47.4, 47.4, 47.4, 47.4, 47.4, 47.4, 47.4],
//     //     [47.38, 47.38, 47.38, 47.38, 47.38, 47.38, 47.38],
//     //     [47.36, 47.36, 47.36, 47.36, 47.36, 47.36, 47.36],
//     //     [47.34, 47.34, 47.34, 47.34, 47.34, 47.34, 47.34],
//     //     [47.32, 47.32, 47.32, 47.32, 47.32, 47.32, 47.32],
//     //     [47.3, 47.3, 47.3, 47.3, 47.3, 47.3, 47.3],
//     //     ];
//     // const z = [
//     //     [null, null, null, null, null, null, null],
//     //     [null, null, null, 2, null, null, null],
//     //     [null, null, 2, 5, 2, null, null],
//     //     [null, 2, 5, 10, 5, 2, null],
//     //     [null, null, 2, 5, 2, null, null],
//     //     [null, null, null, 2, null, null, null],
//     //     [null, null, null, null, null, null, null],
//     //     ];

//     const contourLines = (L as any).contour({x, y, z}, {thresholds:4});

//     // // const bounds = L.latLng(props.center).toBounds(props.size)
//     // // const square = new L.Rectangle(bounds)
//     const container = context.layerContainer || context.map

//     container.addLayer(contourLines);

//     return () => {
//       container.removeLayer(contourLines);
//     }
//   })

//   return null;
// }

const ScenarioPage = () => {
    const mapCenterLatitude = 25.8871016;
    const mapCenterLongitude = 51.5164094;
    const pois : {title:string, lat:number, lng:number}[] = [
        { title:"RLIC Camp", lng:51.561083368099, lat:25.852166662308},
        { title:"RLIC Port", lng:51.590500013801, lat:25.923055535007},
        { title:"Al Khor", lng:51.531527747869, lat:25.723083359207},
        { title:"Al Dhakira", lng:51.501906867142, lat:25.672806299445},
        { title:"Al Jumaliya", lng:51.078111065054, lat:25.625555594206},
        { title:"Al Shamal", lng:51.211583319419, lat:26.125972261818}
    ];
    let loadedAnalysisContourLines : MutableRefObject<AnalysisContourLinesModel[]|undefined>= useRef(undefined) ;
    
    let currentAnimationFrame: MutableRefObject<number|undefined> = useRef(undefined);
    let animationInteval: MutableRefObject<NodeJS.Timer|undefined> = useRef(undefined);
    
    const scenariaService = ScenariaService.getInstance();
    let { scenarioId } = useParams();
    
    const [isScenarioLoading, setIsScenarioLoading] = useState<boolean>(false);
    const [scenario, setScenario] = useState<ScenarioModel|undefined>(undefined);
    const [selectedPollutant, setSelectedPollutant] = useState<PollutantModel|undefined>(undefined);
    const [selectedAnalysis, setSelectedAnalysis] = useState<AnalysisModel|undefined>(undefined);
    const [compatibleAnalysesToCompare, setCompatibleAnalysesToCompare] = useState<AnalysisModel[]>([]);
    const [analysesToCompare, setAnalysesToCompare] = useState<{model: AnalysisModel, receptors:AnalysisDataReceptorModel[]|undefined}[]>([]);
    const [isAnalysisToCompareLoading, setIsAnalysisToCompareLoading] = useState<boolean>(false);
    const [isAnalysisLoading, setIsAnalysisLoading] = useState<boolean>(false);
    const [isShowContourLines, setIsShowContourLines] = useState<boolean>(true);
    const [isShowAnimationControls, setIsShowAnimationControls] = useState<boolean|undefined>(undefined);
    const [isShowScale, setIsShowScale] = useState<boolean>(true);
    const [isSatellite, setIsSatellite] = useState<boolean>(false);
    const [isShowPlotAreaWhenPlotDataIsAvailable, setIsShowPlotAreaWhenPlotDataIsAvailable] = useState<boolean>(true);
    const [isStackedScatterPlot, setIsStackedScatterPlot] = useState<boolean|undefined>(undefined);
    const [isShowCompatibleAnalyses, setIsShowCompatibleAnalyses] = useState<boolean>(false);
    const [currentContourLines, setCurrentContourLines] = useState<AnalysisContourLinesModel|undefined>(undefined);
    const [analysisReceptors, setAnalysisReceptors] = useState<AnalysisDataReceptorModel[]|undefined>(undefined);
    const [dates, setDates] = useState<any[]|undefined>(undefined);
    const [clickMarkers, setClickMarkers] = useState<ClickMarkerModel[]>([]);
    const [selectedMarker, setSelectedMarker] = useState<ClickMarkerModel|undefined>(undefined);
    const [poiMarkers, setPoiMarkers] = useState<ClickMarkerModel[]>([]);
    const [markersToPlot, setMarkersToPlot] = useState<ClickMarkerModel[]>([]);
    const [isAnimating, setIsAnimating] = useState<boolean>(false);
    const [isScenarioInfoModalOpen, setIsScenarioInfoModalOpen] = useState<boolean>(false);
    const [isAboutModalOpen, setIsAboutModalOpen] = useState<boolean>(false);

    const [isGeneratedReportOpen, setIsGeneratedReportOpen] = useState<boolean>(false);
    const [isReportGenerating, setIsReportGenerating] = useState<boolean>(false);
       
    const getClosestReceptor = (lat:number, lng:number, allReceptors:AnalysisDataReceptorModel[]) : AnalysisDataReceptorModel|undefined => {
        if (!allReceptors) return undefined;
        const latLng : LatLng = new LatLng(lat, lng);
        const distancesFromClick = allReceptors.map(r =>latLng.distanceTo({lat:r.lat, lng:r.long}));
        const minDistance = Math.min(...distancesFromClick);
        const indexOfMin = distancesFromClick.indexOf(minDistance);
        return allReceptors[indexOfMin];
    }

    useEffect(()=>{
        if (!scenarioId) return;
        setIsScenarioLoading(true);
        scenariaService.getScenario(Number(scenarioId)).subscribe({
            next:scenario => {
                setIsScenarioLoading(false);

                if (!scenario || scenario === undefined) {
                    notification.error({message:"Error loading scenario"});
                    return;
                }
                setScenario(scenario);
                if (!scenario.pollutants || !scenario.pollutants.length) {
                    notification.error({message:"Scenario seems empty"});
                    return;
                }

                const selectedPollutant = scenario.pollutants[0];
                setSelectedPollutant(selectedPollutant);

                if (!selectedPollutant || selectedPollutant === undefined) return;

                if (!selectedPollutant.analyses || !selectedPollutant.analyses.length) {
                    notification.error({message:"This pollutant has no scenarios"})
                    return;
                }

                setSelectedAnalysis(selectedPollutant.analyses[0]);
            },
            error:() => {
                notification.error({message:"Error loading scenario"});
            }
        });
    },[]);


    useEffect(()=> {
        if (!selectedAnalysis || selectedAnalysis === null) return;
        setAnalysesToCompare([]);
        setCompatibleAnalysesToCompare(selectedPollutant!.analyses.filter(an => an.id !== selectedAnalysis.id && an.time_step_in_hours === selectedAnalysis.time_step_in_hours));
        setIsAnimating(false);
        setIsShowAnimationControls(selectedAnalysis.is_timeseries === false ? undefined : isShowAnimationControls === undefined ? true : isShowAnimationControls);
        setIsStackedScatterPlot(selectedAnalysis.is_timeseries === false ? undefined : isStackedScatterPlot === undefined ? false : isStackedScatterPlot);
        setIsAnalysisLoading(true);
        setCurrentContourLines(undefined);
        setAnalysisReceptors(undefined);
        setClickMarkers([]);
        setPoiMarkers([]);
        setMarkersToPlot([]);
        currentAnimationFrame.current = undefined;
        loadedAnalysisContourLines.current = undefined;
        setDates(undefined);
        scenariaService.getAnalysisReceptorsData(scenario!.id, selectedAnalysis.pollutant_id, selectedAnalysis.id).subscribe({
            next:(receptorsData)=> {
                setAnalysisReceptors(receptorsData);
                const dates = receptorsData[0].data.map(data => data.date).map(date => {
                    if (date) return dayjs(date);
                    return undefined;
                });
                setDates(dates);

                const $contourLines = dates.map(date => scenariaService.getAnalysisContourLines(scenario!.id, selectedAnalysis.pollutant_id, selectedAnalysis.id, date));
                forkJoin($contourLines).subscribe({
                    next:(contourLinesResponses)=> {
                        loadedAnalysisContourLines.current = contourLinesResponses;
                        currentAnimationFrame.current = 0;
                        setCurrentContourLines(loadedAnalysisContourLines.current[0]);
                        setIsAnalysisLoading(false);
                        message.success({content:`Analysis ${selectedAnalysis.title} loaded`});
                    },
                    error:() => {
                        notification.error({message:"Error loading analysis"});
                        setIsAnalysisLoading(false);
                    }
                });
            },
            error:()=> {
                setIsAnalysisLoading(false);
                notification.error({message:"Error loading analysis"});
            }
        });
    }, [selectedAnalysis]);

    useEffect(()=>{
        if (isAnimating) {
            animationInteval.current = setInterval(() => {
                if (currentAnimationFrame.current === dates!.length-1) {
                    currentAnimationFrame.current = 0;
                } else {
                    currentAnimationFrame.current! +=1;
                }
                setCurrentContourLines(loadedAnalysisContourLines.current![currentAnimationFrame.current!]);
            }, 1000);
        } else {
            clearInterval(animationInteval.current);
        }
    },[isAnimating]);

    useEffect(() => {
        const physicalMarkers = clickMarkers.concat(poiMarkers);
        const virtualMarkers : ClickMarkerModel[] = [];
        analysesToCompare.forEach(analysisToCompare => {
            physicalMarkers.forEach(physicalMarker => {
                const closestReceptor = getClosestReceptor(physicalMarker.closestReceptor.lat, physicalMarker.closestReceptor.long, analysisToCompare.receptors!)!;
                virtualMarkers.push({title:physicalMarker.title, analysisTitle:analysisToCompare.model.title, closestReceptor});
            })
        });
        setMarkersToPlot(physicalMarkers.concat(virtualMarkers));
    }, [analysesToCompare, clickMarkers, poiMarkers]);

    return (
        <div style={{height: "100%", width: "100%", position:'relative'}}>
            {isAnalysisLoading && <div style={{ width:'100%', height:'100%', position:'absolute', zIndex:100, backgroundColor:'white', opacity:0.5}}>
                <Spin spinning={true} style={{top:'50%', left:'50%'}}/>
            </div>}
            {scenario ? <>
                <MapContainer center={[mapCenterLatitude, mapCenterLongitude]} zoom={11} style={{height: "100%", width: "100%", position:'absolute',zIndex:0}} zoomControl={false} scrollWheelZoom={true}>
                    <ZoomControl position="bottomleft"/>
                    <TileLayer 
                        url={isSatellite ? "http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}": "https://tile.openstreetmap.org/{z}/{x}/{y}.png"}
                        attribution={isSatellite ? "&copy; Esri" : '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}
                    />
                    {/* <Contour data={loadedAnalysisData} /> */}
                    {isShowContourLines && currentContourLines && currentContourLines.data.map((rm,i) => <Polygon key={i} positions={rm.x.map((x,i) => latLng(rm.y[i], rm.x[i], rm.level))} pathOptions={{color:selectedAnalysis?.scale_definition.scale_items.find(item=>item.upper_limit === rm.level)?.hex_color, fillOpacity:0.4, opacity:0.4, weight:0}}/>)}
                    
                    {analysisReceptors && <MapClickHandler onClick={(e:L.LeafletMouseEvent) => {
                        const closestReceptor = getClosestReceptor(e.latlng.lat, e.latlng.lng, analysisReceptors)!;
                        const clickMarker : ClickMarkerModel = {title:'Marker ' + (clickMarkers.length+1), analysisTitle:selectedAnalysis!.title, closestReceptor};
                        setClickMarkers([...clickMarkers, clickMarker]);
                        }}
                        
                    />}

                    {clickMarkers && clickMarkers.map((m,i) => <Marker key={i} title={m.title} position={{lat:m.closestReceptor.lat, lng:m.closestReceptor.long}} eventHandlers={{
                            popupopen:()=>setSelectedMarker(m),
                            popupclose:()=>setSelectedMarker(undefined)
                        }}>
                        <Popup>
                            <div style={{width:300, height:250, position:'relative'}}>
                                <div style={{position:'absolute', top:0, height:210, overflowY:'auto'}}>
                                    <Descriptions layout="vertical" title={m.title}>
                                        <Descriptions.Item key="position" label="Position" span={3}>Lat: {m.closestReceptor.lat.toFixed(5)}, Lng: {m.closestReceptor.long.toFixed(5)}</Descriptions.Item>
                                        <Descriptions.Item key="concentration" label="Concentration" span={3}>{!currentAnimationFrame.current ? m.closestReceptor.data[0].concentration.toFixed(3) : m.closestReceptor.data.find(d=>d.date === dayjs(dates![currentAnimationFrame.current!]).format("YYYY-MM-DD HH:mm"))!.concentration.toFixed(3)} {selectedAnalysis?.units}</Descriptions.Item>
                                    </Descriptions>    
                                </div>
                                <div style={{position:'absolute', bottom:0, width:'100%'}}>
                                    <Button size="small" onClick={(e)=> {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        const newClickMarkers = [...clickMarkers];
                                        newClickMarkers.splice(i, 1);
                                        setClickMarkers(newClickMarkers);
                                    }}>Remove</Button>
                                </div>
                            </div>
                        </Popup>
                    </Marker>)}

                    {poiMarkers && poiMarkers.map((m,i) => <Marker key={i} title={m.title} position={{lat:m.closestReceptor.lat, lng:m.closestReceptor.long}} eventHandlers={{
                            popupopen:()=>setSelectedMarker(m),
                            popupclose:()=>setSelectedMarker(undefined)
                        }}>
                        <Popup>
                            <div style={{width:300, height:250, position:'relative'}}>
                                <div style={{position:'absolute', top:0, height:210, overflowY:'auto'}}>
                                    <Descriptions layout="vertical" title={m.title}>
                                        <Descriptions.Item key="position" label="Position" span={3}>Lat: {m.closestReceptor.lat.toFixed(5)}, Lng: {m.closestReceptor.long.toFixed(5)}</Descriptions.Item>
                                        <Descriptions.Item key="concentration" label="Concentration" span={3}>{!currentAnimationFrame.current ? m.closestReceptor.data[0].concentration.toFixed(3) : m.closestReceptor.data.find(d=>d.date === dayjs(dates![currentAnimationFrame.current!]).format("YYYY-MM-DD HH:mm"))!.concentration.toFixed(3)} {selectedAnalysis?.units}</Descriptions.Item>
                                    </Descriptions>    
                                </div>
                                <div style={{position:'absolute', bottom:0, width:'100%'}}>
                                    <Button size="small" onClick={(e)=> {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        const newPoiMarkers = [...poiMarkers];
                                        newPoiMarkers.splice(i, 1);
                                        setPoiMarkers(newPoiMarkers);
                                    }}>Remove</Button>
                                </div>
                            </div>
                        </Popup>
                    </Marker>)}
                </MapContainer>

                <Menu mode="horizontal" selectedKeys={[`pollutant_${selectedPollutant?.id}`, `analysis_${selectedAnalysis?.id}`]} items={[
                    {
                        label:'Pollutants',
                        key:'pollutants',
                        children:scenario.pollutants!.map(p => {
                            return {
                                label:p.name,
                                key:`pollutant_${p.id}`,
                                children:p.analyses!.map(a => {
                                    return {
                                        label:a.title,
                                        key:`analysis_${a.id}`,
                                        onClick:()=> {
                                            setSelectedAnalysis(a);
                                            setSelectedPollutant(scenario.pollutants.find(p=>p.id === a.pollutant_id));
                                        }
                                    }
                                })
                            }
                        })
                    },
                    {
                        label:"Map",
                        key:'map',
                        type:'submenu',
                        children: [
                            {
                                label:'Contour lines',
                                key:'contour',
                                icon:isShowContourLines? <CheckOutlined/> : null,
                                onClick:()=>setIsShowContourLines(!isShowContourLines)
                            },
                            {
                                label:'Animation and time controls (timeseries only)',
                                key:'animation',
                                disabled:selectedAnalysis?.is_timeseries === false,
                                icon:isShowAnimationControls? <CheckOutlined/> : null,
                                onClick:()=>setIsShowAnimationControls(isShowAnimationControls=== undefined ? true : !isShowAnimationControls)
                            },
                            {
                                label:'Scale legend',
                                key:'scale',
                                icon:isShowScale? <CheckOutlined/>:null,
                                onClick:()=>setIsShowScale(!isShowScale)
                            },
                            {
                                label:'Satellite map tiles',
                                key:'satellite',
                                icon:isSatellite ? <CheckOutlined/>:null,
                                onClick:()=>setIsSatellite(!isSatellite)
                            },
                            {
                                type:'divider'
                            },
                            {
                                label:'Remove all click markers',
                                key:'remove_click_markers',
                                onClick:()=> setClickMarkers([])
                            }
                        ]
                    },
                    {
                        label:'Plot',
                        key:'plot',
                        type:'submenu',
                        children:[
                            {
                                label:'Show plot(s)',
                                key:'show_plot',
                                icon:isShowPlotAreaWhenPlotDataIsAvailable? <CheckOutlined/> : null,
                                onClick:()=>{
                                    if (!clickMarkers.length && !poiMarkers.length  && isShowPlotAreaWhenPlotDataIsAvailable === false) {
                                        if (selectedAnalysis!.is_timeseries) message.info({content:"Click on map or a POI to show plot data"});
                                    }
                                    setIsShowPlotAreaWhenPlotDataIsAvailable(!isShowPlotAreaWhenPlotDataIsAvailable);
                                }
                            },
                            {
                                label:"Stack scatter plots (timeseries only)",
                                key:'stacked_plots',
                                disabled:selectedAnalysis?.is_timeseries === false,
                                icon:isStackedScatterPlot? <CheckOutlined/> : null,
                                onClick:()=>setIsStackedScatterPlot(isStackedScatterPlot=== undefined ? true : !isStackedScatterPlot)
                            },
                            {
                                label:"Compare with compatible analyses",
                                key:'compare',
                                onClick:()=>setIsShowCompatibleAnalyses(true)
                            }
                        ]
                    },
                    {
                        label:'Points of Interest',
                        key:'pois',
                        type:'submenu',
                        children:[
                            ...pois.map(p => {
                                return {
                                    key:p.title, 
                                    label:p.title,
                                    icon:poiMarkers.find(pm=>pm.title === p.title) ? <CheckOutlined/> :null,
                                    onClick:() => {
                                        const indexOfExisting = poiMarkers.findIndex(pm=>pm.title === p.title);
                                        if (indexOfExisting >=0) {
                                            const newPoiMarkers = [...poiMarkers];
                                            newPoiMarkers.splice(indexOfExisting, 1);
                                            setPoiMarkers(newPoiMarkers);
                                            return;
                                        }
                                        const latLng = new LatLng(p.lat, p.lng);
                                        const closestReceptor = getClosestReceptor(latLng.lat, latLng.lng, analysisReceptors!)!;
                                        const clickMarker : ClickMarkerModel = {title:p.title, analysisTitle:selectedAnalysis!.title, closestReceptor};
                                        setPoiMarkers([...poiMarkers, clickMarker]);
                                    }
                                }
                            }),
                            {
                                type:'divider'
                            },
                            {
                                label:'Select all',
                                key:'poi_all',
                                onClick:()=> {
                                    setPoiMarkers(pois.map(p => {
                                        const latLng = new LatLng(p.lat, p.lng);
                                        const closestReceptor = getClosestReceptor(latLng.lat, latLng.lng, analysisReceptors!)!;
                                        const clickMarker : ClickMarkerModel = {title:p.title, analysisTitle:selectedAnalysis!.title, closestReceptor};
                                        return clickMarker;
                                    }));
                                }
                            },
                            {
                                label:'Select none',
                                key:'poi_none',
                                onClick:()=> {
                                    setPoiMarkers([]);
                                }
                            },
                        ],
                        
                    },
                    {
                        label:'Export and reports',
                        key:'export',
                        type:'submenu',
                        children: [
                            {
                                label:'Generate PDF report',
                                key:'report',
                                onClick:()=> {
                                    setIsGeneratedReportOpen(true);
                                    setIsReportGenerating(true);
                                    (new Promise( resolve => setTimeout(resolve, 3000) )).then(()=> {
                                        setIsReportGenerating(false);
                                    });

                                }
                            },
                            {
                                label:'Export map as image',
                                key:'map_as_image'
                            }
                        ]
                    },
                    {
                        label:'Help',
                        key:'help',
                        type:'submenu',
                        children: [
                            {
                                label:'Scenario info',
                                key:'info',
                                onClick:()=>setIsScenarioInfoModalOpen(true)
                            },
                            {
                                label:'About',
                                key:'about',
                                onClick:()=>setIsAboutModalOpen(true)
                            }
                        ]
                    }
                ]} style={{ opacity:0.8,position:'absolute',top:0, width:'100%'}} />

                {/* title area */}
                <div style={{position:'absolute',top:0, right:0, width:400}}>
                    <Typography.Title level={4} style={{textAlign:'right',lineHeight:'unset', marginTop:10, marginRight:10}}>{scenario.title}</Typography.Title>
                </div>
                {(selectedPollutant && selectedAnalysis) && <div style={{position:'absolute',top:50, left:15, width:"100%"}}>
                    <Typography.Text style={{backgroundColor:'lightgray', opacity:0.9, padding:2, borderRadius:4, lineHeight:'unset', marginTop:10}}><Tooltip title={selectedAnalysis?.description}>{selectedPollutant?.name}: {selectedAnalysis?.title}</Tooltip></Typography.Text>
                </div>}
                {(isShowAnimationControls && dates && currentContourLines && loadedAnalysisContourLines.current) &&  <Card size='small' style={{ opacity:0.8,position:'absolute',bottom:10, left:60, width:300}}>
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
                        <Button shape="circle" icon={<UndoOutlined />} onClick={()=>{
                            currentAnimationFrame.current = 0;
                            setCurrentContourLines(loadedAnalysisContourLines.current![currentAnimationFrame.current!]);
                        }}/>
                        <Button shape="circle" icon={<StepBackwardOutlined />} onClick={()=>{
                            if (currentAnimationFrame.current === 0) return;
                            currentAnimationFrame.current! -=1;
                            setCurrentContourLines(loadedAnalysisContourLines.current![currentAnimationFrame.current!]);
                        }} />
                        <Button shape="circle" icon={isAnimating? <PauseOutlined /> : <CaretRightOutlined />} onClick={()=>{
                            setIsAnimating(!isAnimating);
                        }}/>
                        <Button shape="circle" icon={<StepForwardOutlined />} onClick={()=> {
                            if (currentAnimationFrame.current === dates.length-1) return;
                            currentAnimationFrame.current! +=1;
                            setCurrentContourLines(loadedAnalysisContourLines.current![currentAnimationFrame.current!]);
                        }}/>
                        <div style={{flex:1,textAlign:'right',lineHeight:'30px'}}>
                            {dayjs(dates[currentAnimationFrame.current!]).format('YYYY-MM-DD HH:mm')}
                        </div>

                    </div>
                    <Slider style={{marginBottom:0}} onChange={(value)=>{
                        setCurrentContourLines(loadedAnalysisContourLines.current![value]);
                        currentAnimationFrame.current = value;
                    }} value={currentAnimationFrame.current!} max={dates.length-1} tooltip={{formatter:(value)=>dayjs(dates[value!]).format("YYYY-MM-DD HH:mm")}} marks={Object.fromEntries(dates.map((d:dayjs.Dayjs|undefined, index:number)=> [index, ' ']))} />
                    
                </Card>}

                {(selectedAnalysis && isShowScale) && <Card style={{ opacity:0.8,position:'absolute',bottom:30, right:10, minWidth:100, maxWidth:300, maxHeight:300, overflowY:'auto'}}>
                    {selectedAnalysis.scale_definition.scale_items.map((si,i) => <div style={{display:'flex',flexDirection:'row', alignItems:'center'}} key={i}>
                        <div style={{width:20,height:15, backgroundColor:si.hex_color, borderColor:'gray', borderWidth:1, borderStyle:'solid', marginRight:10}}></div>
                        <div style={{flex:1}}>{si.upper_limit} {selectedAnalysis.units}</div>
                    </div>)}
                </Card>}
                {(isShowPlotAreaWhenPlotDataIsAvailable && (poiMarkers.length || clickMarkers.length)) && <Card style={{ opacity:0.8,position:'absolute',top:80, right:10, width:800, height:500}} title={<div style={{display:'flex', flexDirection:'row' }}>
                    <div style={{flex:1}}>{selectedAnalysis?.is_timeseries ? 'Pollutant concentration over time' : 'Aggregated pollutant concentration'}</div>
                    <div><CloseOutlined onClick={()=>setIsShowPlotAreaWhenPlotDataIsAvailable(false)} /></div>
                </div>}>
                    <Plot
                        config={{
                            displayModeBar:false,
                            displaylogo:false
                        }}
                        data={selectedAnalysis!.is_timeseries ? markersToPlot.map((marker,index) => { 
                            return {
                                type: 'scatter',
                                x:marker.closestReceptor.data.map((d,i)=>dayjs(d.date).format('YYYY-MM-DD HH:mm')),
                                y:marker.closestReceptor.data.map(d=>d.concentration),
                                mode: 'lines+markers',
                                name: Object.keys(groupBy(markersToPlot, 'analysisTitle')).length === 1 ? marker.title : `${marker.title} ${marker.analysisTitle}`.replace(/([\w\s,]{13,}?)\s?\b/g, "$1<br>"),
                                line:{
                                    width: selectedMarker === marker ? 4 : 2
                                },
                                xaxis: isStackedScatterPlot === true ? `x${index+1}`: 'x1',
                                yaxis: isStackedScatterPlot === true ? `y${index+1}` : 'y1'
                            }
                        }): Object.entries(groupBy(markersToPlot, 'analysisTitle')).map(groupOfMarkesToPlot => {
                            const analysisTitle = groupOfMarkesToPlot[0];
                            const markers = groupOfMarkesToPlot[1];
                            return {
                                type: 'bar',
                                name: analysisTitle,
                                x:markers.map(marker => marker.title),
                                y:markers.map(marker => marker.closestReceptor.data[0].concentration)
                            }
                        })
                    }
                        layout={ {
                            margin: {
                                l: 30,
                                r: 60,
                                b: 80,
                                t: 10,
                                pad: 4
                            },
                            grid: {
                                rows:isStackedScatterPlot === true ? markersToPlot.length : 1,
                                columns:1,
                                pattern:'independent',
                                roworder: 'bottom to top'
                            },
                            width: 700, 
                            height: 400, 
                            xaxis:{type: selectedAnalysis!.is_timeseries ? 'date' :'category' , angle:30, tickformat:selectedAnalysis!.is_timeseries ? '%Y-%m-%d %H:%M' : ''},
                            xaxis2:{type: selectedAnalysis!.is_timeseries ? 'date' :'category', visible:false},
                            xaxis3:{type: selectedAnalysis!.is_timeseries ? 'date' :'category', visible:false},
                            xaxis4:{type: selectedAnalysis!.is_timeseries ? 'date' :'category', visible:false},
                            xaxis5:{type: selectedAnalysis!.is_timeseries ? 'date' :'category', visible:false},
                            xaxis6:{type: selectedAnalysis!.is_timeseries ? 'date' :'category', visible:false},
                            xaxis7:{type: selectedAnalysis!.is_timeseries ? 'date' :'category', visible:false},
                            xaxis8:{type: selectedAnalysis!.is_timeseries ? 'date' :'category', visible:false},
                            xaxis9:{type: selectedAnalysis!.is_timeseries ? 'date' :'category', visible:false},
                            yaxis:{minallowed:0},
                            shapes: selectedAnalysis!.is_timeseries ? [{
                            type: 'line',
                            x0: dayjs(dates![currentAnimationFrame.current!]).format('YYYY-MM-DD HH:mm'),
                            y0: 0,
                            x1: dayjs(dates![currentAnimationFrame.current!]).format('YYYY-MM-DD HH:mm'),
                            yref: 'paper',
                            y1: 1,
                            line: {
                              color: 'grey',
                              width: 1.5,
                              dash: 'dot'
                            }
                            }]:[]} 
                        }
                    />
                </Card>}

                <Modal  open={isShowCompatibleAnalyses} closable={true} footer={null} onCancel={()=>setIsShowCompatibleAnalyses(false)} title={'Compare analysis ' + selectedAnalysis?.title + ' with:'}>
                    {compatibleAnalysesToCompare.length ? <div style={{height:200, overflowY:'auto'}}>
                        <Spin spinning={isAnalysisToCompareLoading}>
                        {compatibleAnalysesToCompare.map(compatibleAnalysisToCompare => <Checkbox checked={analysesToCompare.find(ac=>ac.model === compatibleAnalysisToCompare) !== undefined} onChange={(e)=> {
                            if (e.target.checked) {
                                setIsAnalysisToCompareLoading(true);
                                scenariaService.getAnalysisReceptorsData(scenario.id, selectedPollutant!.id, compatibleAnalysisToCompare.id).subscribe({
                                    next:(receptorsOfAnlysisToCompare) => {
                                        const newAnalysesToCompare = [...analysesToCompare];
                                        newAnalysesToCompare.push({model:compatibleAnalysisToCompare, receptors:receptorsOfAnlysisToCompare});
                                        setAnalysesToCompare(newAnalysesToCompare);
                                        setIsAnalysisToCompareLoading(false);
                                    }, error:()=>{
                                        notification.error({message:'Error loading receptors of analysis.'});
                                        setIsAnalysisToCompareLoading(false);
                                    }
                                });
                            } else {
                                const newAnalysesToCompare = [...analysesToCompare];
                                newAnalysesToCompare.splice(newAnalysesToCompare.map(nac=>nac.model).indexOf(compatibleAnalysisToCompare));
                                setAnalysesToCompare(newAnalysesToCompare);
                            }
                        }}>{compatibleAnalysisToCompare.title}</Checkbox>)}
                        </Spin>
                    </div>: <Empty description='No compatible analyses (analyses with the same time step) exist for this pollutant.'/>}
                </Modal>
                <Modal open={isScenarioInfoModalOpen} closable={true} footer={null} onCancel={()=>setIsScenarioInfoModalOpen(false)} title={scenario.title}>
                    <div style={{whiteSpace:'pre-wrap'}}>{scenario.description ?? <Empty description='No description provided'/>}</div>
                </Modal>

                <Modal open={isAboutModalOpen} closable={true} footer={null} onCancel={()=>setIsAboutModalOpen(false)} title="BASQAR: Insightful Decision Support for Airborne Emissions">
                    <div style={{textAlign:'center',height:220, alignContent:'center'}}>
                        <img src={qelng} alt="qenergy-logo" width={100} style={{margin:10}}/>
                        <img src={tamuq} alt="tamuq-logo" width={120} style={{margin:10}}/>
                    </div>
                    <div style={{textAlign:'center', alignContent:'center'}}>
                        TAMUQ&copy; {dayjs().year()}
                    </div>
                </Modal>

                <Modal open={isGeneratedReportOpen} onCancel={()=>setIsGeneratedReportOpen(false)} style={{minWidth:800}} styles={ { content: {width:'fit-content'}}} title='Generated environmental report' footer={[
                    <Button type="primary" disabled={isReportGenerating} icon={<DownloadOutlined/>}>Download</Button>
                ]}>
                    <div style={{width:800, height:600, overflow:'auto',padding:5}}>
                        {isReportGenerating ? <Skeleton/> : <img src={report} width={700}/>}
                    </div>
                </Modal>
            </>
            : <Skeleton loading={isScenarioLoading}/>}
        </div>
    );
  };

  const MapClickHandler = (props:any) => {
    const receptors : AnalysisDataReceptorModel[] = props.receptors;
    const onClick : (e:L.LeafletMouseEvent) => void = props.onClick;
    const context = useLeafletContext()
    useMapEvents({
        click(e) {
            if(onClick) onClick(e);
        },
    });

    return null;
};

  export default ScenarioPage;